import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c5919d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 ModelField-colFirst" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-4 ModelField-colFirst" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1))
const _hoisted_8 = { class: "col-4 ModelField-col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1))
const _hoisted_10 = { class: "col-4 ModelField-colLast" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-4 ModelField-colFirst" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Грузоподъемность (кг)", -1))
const _hoisted_15 = { class: "col-4 ModelField-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Кубатура (объем)", -1))
const _hoisted_17 = { class: "col-4 ModelField-colLast" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отступы", -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-6 ModelField-colFirst" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Максимальная нагрузка на ось прицепа (кг) ", -1))
const _hoisted_22 = { class: "col-6 ModelField-colLast" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Максимальная нагрузка на ось тягача (кг) ", -1))
const _hoisted_24 = { class: "TransportMotorCreateEditDialog_subTableFirstColumn" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Реквизиты", -1))
const _hoisted_26 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    maxWidth: "1000px",
    onOnShown: _ctx.onShown,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_TextControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Наименование...",
                "show-clear-button": true,
                value: model.name,
                "onUpdate:value": ($event: any) => ((model.name) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Длина...",
                min: 0,
                value: model.length,
                "onUpdate:value": ($event: any) => ((model.length) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Ширина...",
                min: 0,
                value: model.width,
                "onUpdate:value": ($event: any) => ((model.width) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Высота...",
                min: 0,
                value: model.height,
                "onUpdate:value": ($event: any) => ((model.height) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Грузоподъемность...",
                decimalPoints: 2,
                min: 0,
                value: model.loadCapacity,
                "onUpdate:value": ($event: any) => ((model.loadCapacity) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Кубатура...",
                decimalPoints: 2,
                min: 0,
                value: model.volume,
                "onUpdate:value": ($event: any) => ((model.volume) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.gapId,
                "onUpdate:id": ($event: any) => ((model.gapId) = $event),
                desc: model.gapDescription,
                "onUpdate:desc": ($event: any) => ((model.gapDescription) = $event),
                displayDescField: "name",
                keyField: "id",
                catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Нагрузка на прицеп...",
                decimalPoints: 2,
                min: 0,
                value: model.trailerLoadCapacity,
                "onUpdate:value": ($event: any) => ((model.trailerLoadCapacity) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Нагрузка на тягач...",
                decimalPoints: 2,
                min: 0,
                value: model.tractorLoadCapacity,
                "onUpdate:value": ($event: any) => ((model.tractorLoadCapacity) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", {
            class: "TransportMotorCreateEditDialog_requisiteSubGrid",
            id: _ctx.requisiteSubGridDomId
          }, null, 8, _hoisted_26)
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}